import { Flex } from '@iheartjane/reefer';
import { Form } from '@iheartjane/reefer-hook-form';
import { useContext } from 'react';

import { GlobalSpecialsModalContext } from '@jane/business-admin/providers';

export const SpendingThreshold = () => {
  const { isDisabled } = useContext(GlobalSpecialsModalContext);

  return (
    <Flex
      justifyContent="space-between"
      width="100%"
      gap={24}
      flexDirection="column"
    >
      <Flex width="100%" gap={24} mb={24}>
        <Form.NumberField
          width={'100%'}
          name={`display.spending_threshold.max_applications_per_cart`}
          label={'Maximum uses per order'}
          disabled={isDisabled}
          min={1}
          disableOnWheel
        />
      </Flex>
    </Flex>
  );
};
